<template>
  <div>
    <m-single-product-wrapper :product-link="productLink" @product="dataReady">
      <template v-slot="{product}">
        <div>


          <div class="container single-product-400">

            <div class="row single-product-400-row">


              <div class="col-lg-4 single-product-400-col-lg-4 ">

                <div class="single-product-400-sticky-top sticky-top mt-3">


                  <div class="single-product-400-profile-img-panel border rounded text-center">

                    <img :src="product.thumbnail" :alt="product.name"
                         class="rounded rounded-circle img-fluid p-3 single-product-400-img ">

                    <h3 class="text-center single-product-400-name">{{ product.name }}</h3>

                    <div class="single-product-400-keywords p-3">
                      <span class="mx-2 btn btn-sm btn-primary rounded-pill"
                            v-for="keyword in product.keywords">{{ keyword.keyword }}</span>
                    </div>


                  </div>

                </div>

              </div>


              <div class="col-lg-8 single-product-400-col-lg-8">
                <ul class="nav nav-pills my-3 " id="pills-tab" role="tablist">
                  <li class="nav-item">
                    <a :class="{' active':(productInfoTab==='description')}" class="nav-link " id="pills-home-tab"
                       data-toggle="pill" href="#pills-home" role="tab"
                       aria-controls="pills-home" aria-selected="true" v-t="`product.single.description`"></a>
                  </li>
                  <li class="nav-item">
                    <a :class="{' active':(productInfoTab==='profile')}" class="nav-link" id="pills-profile-tab"
                       data-toggle="pill" href="#pills-profile" role="tab"
                       aria-controls="pills-profile" aria-selected="false" v-t="`product.single.profile`"></a>
                  </li>
                  <li class="nav-item">
                    <a :class="{' active':(productInfoTab==='detail')}" class="nav-link" id="pills-contact-tab"
                       data-toggle="pill" href="#pills-contact" role="tab"
                       aria-controls="pills-contact" aria-selected="false" v-t="`product.single.detail`"></a>
                  </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">

                  <div class="tab-pane fade " :class="{'show active':(productInfoTab==='description')}"  id="pills-home" role="tabpanel"
                       aria-labelledby="pills-home-tab">

                    <m-single-product-price3 class="text-center" :product="product"/>


                  </div>

                  <div class="tab-pane fade" :class="{'show active':(productInfoTab==='profile')}" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab"
                       v-html="processContent(product.description)">
                  </div>

                  <div class="tab-pane fade" :class="{'show active':(productInfoTab==='detail')}" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                    <single-product-table-feature1 :product="product"/>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </template>
    </m-single-product-wrapper>


  </div>
</template>

<script>
import mSingleProductWrapper from "../../Wrappers/SingleProductWrapper";
import mSingleProductPriceWrapper from "../../Product/SingleProductPriceWrapper";
import mH2 from "../../Tags/H2";
import mA from "../../Tags/A";
import mProductPrice100 from "../../Product/ProductPrice100";
import mSingleProductPrice3 from "../SingleProductPrice3/SingleProductPrice3";
import mProductSlider1 from "../ProductSlider/ProductSlider1";
import mContentSlider4 from "../../Content/Slider/ContentSlider4";
import mCourseCard1 from "../../Course/Card/CourseCard1";
import mHtmlToComponentWrapper from "../../Wrappers/HtmlToComponentWrapper";
import product, {
  productFeatureName,
  productFeatureValue,
  productTableFeature
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import SingleProductGallery1 from "./Components/SingleProductGallery1.vue";
import SingleProductTableFeature1 from "./Components/SingleProductTableFeature1.vue";

export default {
  name: "SingleProduct400",
  computed: {
    product() {
      return product
    }
  },
  props: {
    productLink: {
      default: null
    },
    relatedProducts: {
      type: Boolean,
      default: true
    },
    productCardName: {
      default: 'm-product-card309',
    },
    relatedPosts: {
      type: Boolean,
      default: true,
    },
    relatedCourse: {
      type: Boolean,
      default: false,
    },
    productInfoTab: {
      options: ['detail', 'description', 'profile'],
      default: 'detail',
    },
    galleryFullSlider: {
      type: Boolean,
      default: false
    },
  },
  components: {
    SingleProductGallery1,
    mSingleProductWrapper,
    mH2,
    mSingleProductPriceWrapper,
    mProductPrice100,
    mSingleProductPrice3,
    mProductSlider1,
    mA,
    mContentSlider4,
    mCourseCard1,
    mHtmlToComponentWrapper,
    SingleProductTableFeature1,
  },
  data() {
    return {};
  },
  methods: {
    productFeatureValue,
    productFeatureName,
    productTableFeature,
    dataReady(product) {
    },
    productCategories(product) {
      if (product.category != undefined) {
        let categories = product.category.map(item => {
          return item.slug;
        })

        return categories.length == 0 ? null : categories
      }

    },
    productBrands(product) {
      const brand = product.brand;
      return brand == null ? null : [brand.slug];
    },
    generateInstagram() {
      const instagrams = this.findAttributeOnSiteInfo('social_media_instagram');
      if (instagrams.length > 0) {
        let instagram = instagrams[0];
        let instagramLink = instagram;

        instagram = instagram.split('/');
        // remove empty element
        instagram = instagram.filter(function (el) {
          return el != '';
        });

        return {'link': instagramLink, 'id': instagram.slice(-1)[0]}
      }
      return false;
    },
  },
};
</script>


<style scoped>
.single-product-400-img {
  height: 300px;
  width: 300px;
  object-fit: cover;
}

</style>